import DC from "../../common/DataConnector";
import Helpers from "../../common/Helpers";
import StoreValueModel from "../StoreValueModel";
import LocalDataStore from "../../common/LocalDataStore";
import { reducerLoadLocations, reducerLoadProvinces } from "./LoaderCommonsReducer";
import { reducerAppData } from "../AppData/AppDataReducer";

export async function commonLoadLocations(dic: StoreValueModel, dispatch: any, secondsExpire: number = 600) {
    if (dic.type === undefined) return;
    if (!Helpers.DateCurrentGreatThanSeconds(dic.updatedAt, secondsExpire))
        return;

    const updatedAt = new Date().getTime()

    const locations = await DC.Get('/customer/locations');
    if (locations.wasOk) {
        let defaultLocationCode = '';
        dispatch(reducerLoadLocations({ locations: { list: locations.data, updatedAt: updatedAt, type: 'list' } }))
        if (locations.data.length === 1) {
            dispatch(reducerAppData({ location: locations.data[0] }))
        }
        // Comprobamos si la location que tenemos en store es valida. 
        if (locations.data.length > 0) {
            const locationCurrent = LocalDataStore.locationGet();
            if (locationCurrent !== '' && locations.data.filter((i: { code: string; }) => i.code === locationCurrent).length === 0) {
                LocalDataStore.locationClear();
            }
            if (locationCurrent && locationCurrent !== '')
                defaultLocationCode = locationCurrent;
            else
                defaultLocationCode = locations.data[0].code
        }
        return defaultLocationCode;
    }

}


export async function commonLoadProvinces(dic: StoreValueModel, dispatch: any, secondsExpire: number = 600) {
    if (dic.type === undefined) return;
    if (!Helpers.DateCurrentGreatThanSeconds(dic.updatedAt, secondsExpire))
        return;

    const updatedAt = new Date().getTime()
    const provinces = await DC.Get('/customer/common/provinces', {});
    if (provinces.wasOk) {
        dispatch(reducerLoadProvinces( { list: provinces.data, updatedAt: updatedAt, type: 'list' } ))
    }
}